import * as React from 'react';
import { styled } from '@linaria/react';

import Demo, { DemoSliderControl } from '@/components/Demo';
import SvgWithGrid from '@/components/SvgWithGrid';

import Yeehaw from './Yeehaw';

interface Props {
  variant?: 'default' | 'angled';
}

function ArcRotateDemo({ variant = 'default' }: Props) {
  return (
    <Demo
      outputWrapper={null}
      initialValues={{
        rotation: 0,
      }}
      customGrid={{
        gridTemplateColumns: 'min(400px, 100%)',
        justifyContent: 'center',
      }}
      controlPosition="bottom"
      controls={[
        <DemoSliderControl
          id="rotation"
          key="rotation"
          label="Rotation"
          min={variant === 'default' ? -90 : 0}
          max={90}
          step={1}
          notchValue={variant === 'default' ? 0 : 45}
          previewRenderer={(value) => {
            if (value == 0) {
              return '0° (default)';
            }
            return `${value}°`;
          }}
        />,
      ]}
    >
      {({ rotation }) => {
        return (
          <Wrapper>
            <Svg gridGap={2} lineWidth={0.1} viewBox={`0 0 32 32`}>
              {variant === 'default' && (
                <>
                  <Ellipse
                    d={`
                  M 0,16
                  L 10,16
                  A 6,10 ${rotation} 1 0 22,16
                  L 32,16
                  `}
                  />
                  <Path
                    d={`
                M 0,16
                L 10,16
                A 6,10 ${rotation} 0 1 22,16
                L 32,16
                `}
                  />
                  <Joint r={0.625} cx={10} cy={16} />
                  <Joint r={0.625} cx={22} cy={16} />
                </>
              )}
              {variant === 'angled' && (
                <>
                  <Ellipse
                    d={`
                      M 8,8
                      L 12,12
                      A 5,8 ${rotation} 1 0 20,20
                      L 24,24
                    `}
                  />
                  <Path
                    d={`
                      M 8,8
                      L 12,12
                      A 5,8 ${rotation} 0 1 20,20
                      L 24,24
                    `}
                    strokeLinecap="round"
                  />
                  <Joint r={0.625} cx={12} cy={12} />
                  <Joint r={0.625} cx={20} cy={20} />
                </>
              )}
            </Svg>
            <DesktopOnly>
              {variant === 'angled' && (
                <Yeehaw isVisible={rotation === 45} />
              )}
            </DesktopOnly>
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 300px;
  margin-inline: auto;
  padding-block: 16px;
`;

const Svg = styled(SvgWithGrid)`
  display: block;
  aspect-ratio: 1;
  border-radius: 4px;
  outline: 1px solid var(--color-gray-300);
`;

const Ellipse = styled.path`
  fill: none;
  stroke: white;
  stroke-width: 0.5;
  stroke-dasharray: 1 1;
`;

const Path = styled.path`
  fill: none;
  stroke: hsl(220deg 90% 65%);
  stroke-width: 1;
`;

const Joint = styled.circle`
  fill: white;
  stroke: var(--color-background);
  stroke-width: 0.25;
`;

const DesktopOnly = styled.div`
  @media (max-width: 32rem) {
    display: none;
  }
`;

export default ArcRotateDemo;
